import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tournaments-view"
}
const _hoisted_2 = {
  class: "tournaments-headline",
  "data-qe-id": "tournament-name"
}
const _hoisted_3 = { class: "tournament-info" }
const _hoisted_4 = { class: "t-table-header" }

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import CGamesOverview from '@/components/CGamesOverview.vue'
import CTournamentInfo from '@/components/CTournamentInfo.vue'
import MTournamentTable from '@/modules/MTournamentTable.vue'
import CTournamentHeader from '@/components/CTournamentHeader.vue'
import CJoinedTemplate from '@/components/CJoinedTemplate.vue'
import CNavigation from '@/components/CNavigation.vue'
import { ERROR_CODES } from '@/model/ErrorCodes'
import MResultModal from '@/modules/MResultModal.vue'
import CFinishedLaurel from '@/components/CTournamentLaurel.vue'
import { TOURNAMENT_LAUREL_STATE } from '@/components/CTournamentLaurel.vue'
import { events } from '@gd/event-bus'


export default /*@__PURE__*/_defineComponent({
  __name: 'TournamentHistoryView',
  props: {
    tId: {},
    zoneId: {}
  },
  emits: ['tournament-info-modal'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const router = useRouter()
const store = useStore()

const isLoading = ref(true)
const gameSelectedCompetitionId = ref('')
const showResultModal = ref(false)

const tournament = computed(() => {
  return store.getters['history/tournamentUi']
})

const isMasters = computed(() => {
  return store.getters['history/tournamentUi'].isMasters
})

const games = computed(() => {
  const games = store.getters['history/tournamentUi'].games
  // console.log('games', games)
  return games
})

function onGame(game: any) {
  gameSelectedCompetitionId.value = game.competitionId
  showResultModal.value = true
}

store.commit('history/zoneId', props.zoneId)
store
  .dispatch('history/fetchTournamentHistoryById', props.tId)
  .then(() => {
    isLoading.value = false
  })
  .catch((err: any) => {
    if (err && err.errorCode === 401) {
      router.replace('/extern/login')
    } else {
      router.push({ path: `/error/ ${(err && err.errorCode) || ERROR_CODES.UNKNOWN}/${props.zoneId}` })
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_c_loading_indicator = _resolveComponent("c-loading-indicator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_t_text = _resolveComponent("t-text")!
  const _component_t_container = _resolveComponent("t-container")!
  const _component_t_content = _resolveComponent("t-content")!

  return (_openBlock(), _createBlock(_component_t_content, {
    main: "",
    class: "tournaments-history-view",
    "data-qe-id": "tournament-history-view"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_c_loading_indicator, {
        class: "modal-spinner",
        show: isLoading.value
      }, null, 8, ["show"]),
      _createVNode(CTournamentHeader, {
        zone: _ctx.zoneId,
        language: _ctx.$i18n.locale
      }, null, 8, ["zone", "language"]),
      _createVNode(CNavigation, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: { path: `/tournaments/${_ctx.zoneId}`, query: { table: 'history' } },
            "data-qe-id": "back-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('tournamentHistory.main.back_button')), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }),
      (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_t_text, { class: "tournament-header" }, {
              default: _withCtx(() => [
                _createElementVNode("h1", _hoisted_2, _toDisplayString(tournament.value.name), 1),
                _createElementVNode("span", {
                  class: "winning-distribution-info",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(events).$emit('tournament-info-modal', { tournamentUi: tournament.value, trackId: 'header' }))),
                  "data-qe-id": "win-distribution-trigger"
                }, _cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "icf-info icon-info" }, null, -1)
                ]))
              ]),
              _: 1
            }),
            _createVNode(CJoinedTemplate, {
              class: "joined-template-board",
              isMasters: isMasters.value
            }, {
              default: _withCtx(() => [
                _createVNode(CGamesOverview, {
                  onOnGame: onGame,
                  games: games.value,
                  "is-history-mode": true
                }, {
                  header: _withCtx(() => [
                    (tournament.value.tournamentRank)
                      ? (_openBlock(), _createBlock(CFinishedLaurel, {
                          key: 0,
                          class: "tournament-finished-laurel",
                          state: _unref(TOURNAMENT_LAUREL_STATE).HISTORY,
                          score: tournament.value.tournamentScore,
                          rank: tournament.value.tournamentRank
                        }, null, 8, ["state", "score", "rank"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["games"]),
                (showResultModal.value)
                  ? (_openBlock(), _createBlock(MResultModal, {
                      key: 0,
                      onClose: _cache[1] || (_cache[1] = ($event: any) => (showResultModal.value = false)),
                      "competition-id": gameSelectedCompetitionId.value
                    }, null, 8, ["competition-id"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["isMasters"]),
            _createElementVNode("section", _hoisted_3, [
              _createVNode(CTournamentInfo, {
                "tournament-ui": tournament.value,
                "meta-data": tournament.value.metaData,
                dates: tournament.value.dates,
                "show-registration-end": false
              }, null, 8, ["tournament-ui", "meta-data", "dates"])
            ]),
            _createVNode(_component_t_container, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('tournamentHistory.main.table_title', { tournamentName: tournament.value.name })), 1),
                _createVNode(MTournamentTable, {
                  "t-id": _ctx.tId,
                  "show-history-mode": true,
                  "data-qe-id": "table-history"
                }, null, 8, ["t-id"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})